import { render, staticRenderFns } from "./our_work.vue?vue&type=template&id=f2fd4056&scoped=true&"
import script from "./our_work.vue?vue&type=script&lang=js&"
export * from "./our_work.vue?vue&type=script&lang=js&"
import style0 from "./our_work.vue?vue&type=style&index=0&id=f2fd4056&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2fd4056",
  null
  
)

export default component.exports